var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("支付详情"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 820
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("交易流水号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.payNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "payNo", $$v);
      },
      expression: "dataFrom.payNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保流水号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.searchNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "searchNo", $$v);
      },
      expression: "dataFrom.searchNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付方式")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.payType,
      callback: function ($$v) {
        _vm.payType = $$v;
      },
      expression: "payType"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单金额")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.orderAmount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "orderAmount", $$v);
      },
      expression: "dataFrom.orderAmount"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付金额")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.realPayAmount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "realPayAmount", $$v);
      },
      expression: "dataFrom.realPayAmount"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("应用名称")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.applicationName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "applicationName", $$v);
      },
      expression: "dataFrom.applicationName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付场景")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.operationName,
      callback: function ($$v) {
        _vm.operationName = $$v;
      },
      expression: "operationName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("账号主体")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.customerName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "customerName", $$v);
      },
      expression: "dataFrom.customerName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付时间")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.paymentAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "paymentAt", $$v);
      },
      expression: "dataFrom.paymentAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付状态")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.statusName,
      callback: function ($$v) {
        _vm.statusName = $$v;
      },
      expression: "statusName"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };